import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, X } from 'lucide-react';
import TopBar from '../components/TopBar';

const Subscription = () => {
  const navigate = useNavigate();
const handleSelectPlan = (plan) => {

if(plan.id === "free"){

window.location.href="http://www.anvysoft.com/api/auth/google";

}

else{

alert("Payment integration coming soon");

}

};
  const plans = [
    {
      id: 'free',
      name: 'Free',
      icon: '✓',
      price: 0,
      period: 'One time only',
      description: 'Try with 5 AI replies (one time)',
      features: [
        { text: '5 AI replies total (lifetime)', available: true },
        { text: '1 Google Business profile', available: true },
        { text: 'No bulk post', available: false },
        { text: 'Basic tone only', available: false },
        { text: 'No monthly reset', available: false },
      ],
      buttonText: 'Start for Free',
      buttonClass: 'bg-green-600 hover:bg-green-700',
      bgClass: 'bg-[#ECFDF5]',
    },
    {
      id: 'basic',
      name: 'Basic',
      icon: '🔷',
      price: 499,
      period: '/month',
      description: 'Best for local shops, salons, & clinics',
      features: [
        { text: '200 AI replies / month', available: true },
        { text: 'Edit before posting', available: true },
        { text: 'Post replies directly to Google', available: true },
        { text: '1 business location', available: true },
      ],
      buttonText: 'Get Started',
      buttonClass: 'bg-blue-600 hover:bg-blue-700',
      bgClass: 'bg-[#EFF6FF]',
      illustration: '🏪',
    },
    {
      id: 'pro',
      name: 'Pro',
      icon: '⭐',
      price: 999,
      period: '/month',
      description: 'Best for hotels, restaurants, & cafes',
      features: [
        { text: '1,000 AI replies / month', available: true },
        { text: 'Post All Replies (one click)', available: true },
        { text: 'Advanced tones (apology, friendly)', available: true },
        { text: 'Manage up to 3 locations', available: true },
      ],
      buttonText: 'Get Started',
      buttonClass: 'bg-purple-600 hover:bg-purple-700',
      bgClass: 'bg-[#F5F3FF]',
      popular: true,
      illustration: '🏨',
    },
    {
      id: 'business',
      name: 'Business/Agency',
      icon: '📊',
      price: 2499,
      period: '/month',
      description: 'For agencies & large businesses',
      features: [
        { text: 'Unlimited replies', available: true },
        { text: 'Manage 10+ locations', available: true },
        { text: 'Team access & analytics', available: true },
        { text: 'Priority support', available: true },
      ],
      buttonText: 'Get Started',
      buttonClass: 'bg-orange-600 hover:bg-orange-700',
      bgClass: 'bg-[#FFF7ED]',
      illustration: '💼',
    },
  ];

  

  return (
    <div className="flex flex-col w-full min-h-screen bg-slate-50">
      <TopBar />
      
      <div className="flex-1 p-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-slate-900 mb-3">Simple, Affordable Pricing</h1>
            <p className="text-lg text-slate-600">
              Choose the perfect plan for your business. No hidden fees, cancel anytime.
            </p>
          </div>

          {/* Rocket Decoration */}
          <div className="flex justify-center mb-12">
            <div className="flex gap-8">
              {['🚀', '🚀', '🚀'].map((rocket, i) => (
                <div
                  key={i}
                  className="text-6xl transform hover:translate-y-[-10px] transition-transform duration-300"
                  style={{ animationDelay: `${i * 0.2}s` }}
                >
                  {rocket}
                </div>
              ))}
            </div>
          </div>

          {/* Pricing Cards */}
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-6 mb-8">
            {plans.map((plan) => (
              <div
                key={plan.id}
                className={`${plan.bgClass} rounded-3xl p-6 sm:p-8 relative transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl border-2 ${
                  plan.popular ? 'border-purple-400' : 'border-transparent'
                }`}
                style={{ width: '100%', maxWidth: '400px', minWidth: '260px' }}
                data-testid={`pricing-card-${plan.id}`}
              >
              {/* Popular Badge */}
              {plan.popular && (
                <div
                  className="absolute top-4 right-4 bg-yellow-400 text-yellow-900 px-3 py-1 rounded-full text-xs font-bold"
                  data-testid="most-popular-badge"
                >
                  MOST POPULAR
                </div>
              )}

              {/* Icon */}
              <div className="w-12 h-12 bg-white/80 rounded-2xl flex items-center justify-center text-2xl mb-4 shadow-sm">
                {plan.icon}
              </div>

              {/* Plan Name */}
              <h3 className="text-2xl font-bold text-slate-900 mb-4">{plan.name}</h3>

              {/* Price */}
              <div className="mb-4">
                <div className="flex items-baseline">
                  <span className="text-5xl font-bold text-slate-900">₹{plan.price}</span>
                  {plan.price > 0 && <span className="text-lg text-slate-600 ml-2">{plan.period}</span>}
                </div>
                {plan.price === 0 && <p className="text-sm text-slate-600 mt-1">{plan.period}</p>}
              </div>

              {/* Description */}
              <p className="text-sm text-slate-700 mb-6 min-h-[40px]">{plan.description}</p>

              {/* Features */}
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-2">
                    {feature.available ? (
                      <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    ) : (
                      <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                    )}
                    <span
                      className={`text-sm ${
                        feature.available ? 'text-slate-900' : 'text-slate-500 line-through'
                      }`}
                    >
                      {feature.text}
                    </span>
                  </li>
                ))}
              </ul>

              {/* Illustration */}
              {plan.illustration && (
                <div className="mb-6 text-center">
                  <div className="text-4xl">{plan.illustration}</div>
                </div>
              )}

              {/* Button */}
              <button
                onClick={() => handleSelectPlan(plan)}
                className={`w-full ${plan.buttonClass} text-white font-semibold py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2`}
                data-testid={`select-plan-btn-${plan.id}`}
              >
                {plan.buttonText}
                <span>→</span>
              </button>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="text-center">
          <p className="text-sm text-slate-600">
            All plans include a 14-day free trial. No credit card required.
          </p>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
